<template>
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">CADASTRO DE DEPENDENTE</span>
  </div>
  &nbsp;<br />
  <form class="row g-3 needs-validation" novalidate>
    <div class="row">
      <div class="col-3" style="width: 19%">
        <div class="row">
          <div class="col d-flex justify-content-center">
            <img style="max-height: 240px; max-width: 235px" alt="" id="imgFoto" class="rounded" />
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-center">
            <input id="uploadImg" type="file" ref="uploadImg" v-on:change="uploadFileImg" />
            <a style="color: deepskyblue" id="upload_img" @click="openUploadImg" ref="uploadImgClick">Incluir foto</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-3">
            <label for="tipoPaciente">Tipo Paciente</label>
            <input type="text" class="form-control form-input-component" v-model="form.tipoPaciente" aria-describedby="tipoPaciente" id="tipoPaciente" v-bind:class="{ 'is-invalid': submitted && form.tipoPaciente.length === 0 }" required disabled />
          </div>
          <div class="col">
            <div class="row">
              <label>CPF do Responsável</label>
              <div class="col" style="padding-right: 0">
                <div class="input-group input-focus">
                  <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" v-model="form.dependenteMilitar.cpf" ref="cpfDependenteMilitar" id="cpfDependenteMilitar" required v-bind:class="{ 'is-invalid': submitted && form.dependenteMilitar.cpf.length === 0 }" disabled />
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <label>Nome do Responsável</label>
              <div class="col" style="padding-right: 0">
                <div class="input-group input-focus">
                  <input type="text" class="form-control form-input-component" v-model="form.dependenteMilitar.nome" id="nomeDependenteMilitar" v-bind:class="{ 'is-invalid': submitted && form.dependenteMilitar.nome.length === 0 }" required disabled />
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <label>Grau Parentesco</label>
            <select required class="form-select form-input-component" v-model="form.grauParentesco" v-bind:class="{ 'is-invalid': submitted && !form.grauParentesco }">
              <option v-for="item in enumGrauParentesco" :key="item.id" :value="item">
                {{ item.nome }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <label for="cpf">CPF</label>
            <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" v-model="form.cpf" ref="cpf" id="cpf" required v-bind:class="{ 'is-invalid': submitted && !form.cpf }" @keyup="validarCpf" />
          </div>
          <div class="col">
            <label for="nome">Nome completo</label>
            <input type="text" class="form-control form-input-component" v-model="form.nome" id="nome" aria-describedby="nome" v-bind:class="{ 'is-invalid': submitted && !form.nome }" required />
          </div>

          <div class="col-2">
            <label for="rgCivil">RG</label>
            <input type="text" class="form-control form-input-component" v-model="form.rgCivil" id="rgCivil" v-bind:class="{ 'is-invalid': submitted && !form.rgCivil }" required />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label>Data Nascimento</label>
            <input type="text" v-model="form.dtNascimento" class="form-control form-input-component" v-mask="'##/##/####'" id="dtNascimento" placeholder="Ex: 20/02/1990" onc v-bind:class="{ 'is-invalid': submitted && !form.dtNascimento }" required @blur="calcularIdade" />
          </div>

          <div class="col">
            <label for="idade">Idade</label>
            <input type="number" v-model="form.idade" class="form-control form-input-component" id="idade" v-bind:class="{ 'is-invalid': submitted && !form.idade }" required disabled />
          </div>

          <div class="col">
            <label for="telefoneCelular">Telefone Celular</label>
            <input type="text" v-model="form.telefoneCelular" v-mask="'(##) #####-####'" class="form-control form-input-component" id="telefoneCelular" v-bind:class="{ 'is-invalid': submitted && !form.telefoneCelular }" required />
          </div>
          <div class="col">
            <label for="telefoneResidencial">Telefone Fixo</label>
            <input type="text" v-model="form.telefoneResidencial" v-mask="'(##) ####-####'" class="form-control form-input-component" id="telefoneResidencial" aria-required="false" />
          </div>

          <div class="col">
            <label for="naturalidade">Naturalidade</label>
            <input type="text" v-model="form.naturalidade" class="form-control form-input-component" id="naturalidade" placeholder="Ex: Goiânia-GO" v-bind:class="{ 'is-invalid': submitted && !form.naturalidade }" required />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label>Estado Civil</label>
            <select class="form-select" v-model="form.estadoCivil" v-bind:class="{ 'is-invalid': submitted && !form.estadoCivil }" required>
              <option v-for="item in estadosCivis" :key="item.id" :value="item">
                {{ item.nome }}
              </option>
            </select>
          </div>

          <div class="col">
            <label>Grau de Escolaridade</label>
            <select class="form-select" v-model="form.grauEscolaridade">
              <option v-for="item in grauEscolaridade" :key="item.id" :value="item">
                {{ item.nome }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-2" style="width: 11.666667%">
        <label for="cep">CEP</label>
        <input type="text" class="form-control form-input-component" id="cep" ref="cep" v-mask="'##.###-###'" @keyup="searchCep" v-model="outForm.cep" v-bind:class="{ 'is-invalid': submitted && $refs.cep.value.length === 0 }" required />
      </div>
      <div class="col">
        <label for="logradouro">Endereço</label>
        <input type="text" class="form-control form-input-component" id="logradouro" v-model="outForm.logradouro" v-bind:class="{ 'is-invalid': submitted && !outForm.logradouro }" aria-describedby="logradouro" required />
      </div>
      <div class="col-1" style="width: 6.333333%">
        <label for="quadra">Quadra</label>
        <input type="text" v-model="outForm.quadra" class="form-control form-input-component" id="quadra" required />
      </div>

      <div class="col-1" style="width: 6.333333%">
        <label for="lote">Lote</label>
        <input type="text" v-model="outForm.lote" class="form-control form-input-component" id="lote" required />
      </div>

      <div class="col">
        <label for="setor">Setor</label>
        <input type="text" v-model="outForm.setor" v-bind:class="{ 'is-invalid': submitted && !outForm.setor }" class="form-control form-input-component" id="setor" required />
      </div>

      <div class="col-1">
        <label for="numero">Número</label>
        <input type="text" v-model="outForm.numero" class="form-control form-input-component" id="numero" required />
      </div>
      <div class="col">
        <label for="complemento">Complemento</label>
        <input type="text" class="form-control form-input-component" id="complemento" v-model="outForm.complemento" aria-describedby="complemento" />
      </div>
      <div class="col">
        <label for="cidade">Cidade</label>
        <input type="text" class="form-control form-input-component" id="cidade" v-model="outForm.cidade" v-bind:class="{ 'is-invalid': submitted && !outForm.cidade }" aria-describedby="cidade" required />
      </div>
      <div class="col-1" style="width: 7.333333%">
        <label for="complemento">Estado</label>
        <input type="text" class="form-control form-input-component" id="estado" v-model="outForm.uf" v-bind:class="{ 'is-invalid': submitted && !outForm.uf }" aria-describedby="estado" required />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label for="profissao">Profissão</label>
        <input type="text" v-model="form.profissao" v-bind:class="{ 'is-invalid': submitted && !form.profissao }" ref="profissao" class="form-control form-input-component" id="profissao" required />
      </div>
      <div class="col">
        <label for="email">E-mail</label>
        <input type="text" v-model="form.email" v-bind:class="{ 'is-invalid': submitted && !form.email }" ref="email" @keyup="validarEmail" class="form-control form-input-component" id="email" required />
      </div>
    </div>
    <div class="row">
      <div class="row" style="display: flex; justify-content: center; align-items: center; margin: 0px; padding: 0px">
        <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6 form-check-item">
          <label style="margin-right: 15px">Convênio</label>
          <div class="form-check form-check-inline form-check-item">
            <input class="form-check-input form-checkbox-box" v-model="form.convenios" v-bind:class="{ 'is-invalid': submitted && !form.convenios.length != 0 }" type="checkbox" ref="ipasgo" value="IPASGO" id="ipasgo" v-on:change="setConvencio('IPASGO')" />
            <label class="form-check-label" for="ipasgo"> Ipasgo </label>
          </div>
          <div class="form-check form-check-inline form-check-item" style="margin-left: 10px">
            <input class="form-check-input form-checkbox-box" v-model="form.convenios" v-bind:class="{ 'is-invalid': submitted && !form.convenios.length != 0 }" type="checkbox" ref="doacao" value="DOACAO" id="doacao" v-on:change="setConvencio('DOACAO')" />
            <label class="form-check-label" for="doacao"> Doação </label>
          </div>
          <div class="form-check form-check-inline form-check-item" style="margin-left: 10px">
            <input class="form-check-input form-checkbox-box" v-model="form.convenios" v-bind:class="{ 'is-invalid': submitted && !form.convenios.length != 0 }" type="checkbox" ref="particular" value="PARTICULAR" id="particular" v-on:change="setConvencio('PARTICULAR')" />
            <label class="form-check-label" for="particular"> Particular </label>
          </div>
        </div>
        <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
          <label for="numeroConvenio">Número do Convênio</label>
          <input type="text" v-model="form.numeroConvenio" ref="numeroConvenio" class="form-control form-input-component" id="numeroConvenio" />
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 10px">
      <div class="col-6">
        <div class="row">
          <div class="col">
            <label for="formFileSm" class="form-label">Tipo Documento</label>
            <select class="form-select" ref="tipoDocumento">
              <option v-for="item in enumTipoDocumento" :key="item" :value="item.tipo">
                {{ item.descricao }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label for="formFileSm" class="form-label">Importar Arquivo</label>
            <input class="form-control form-control-sm" id="formFileSm" type="file" name="file" ref="files" multiple v-on:change="uploadFile" />
          </div>
        </div>
      </div>
      <div class="col">
        <a-table :dataSource="dataDocuments" :columns="columns">
          <template #nomeArquivo="{ record }">
            <span>{{ record.nomeArquivo }}</span
            ><i class="far fa-file-alt" style="margin-left: 5px; cursor: pointer" @click="baixarArquivo(record)"></i>
          </template>
          <template #tipoDocumento="{ record }">
            <span>{{ stringTipoDocumento(record) }}</span>
          </template>
          <template #action="{ record }">
            <a @click="removeDataArchive(record)"><i class="fas fa-trash icon-trash"></i></a>
          </template>
          <template>
            <a-pagination :total="500" />
          </template>
        </a-table>
      </div>
    </div>

    <div class="row justify-content-end" style="margin-top: 10px">
      <div class="col">
        <div class="float-end">
          <button type="button" class="btn btn-primary" @click="this.$router.push({ path: '/paciente-page' })">Voltar</button>&nbsp;
          <button type="button" class="btn btn-primary" @click="saveAndContinue(v$.form.$invalid, false)">Salvar e continuar</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { downloadDocumentFileWs, isArquivoValido, loadDocumentFileWs, sendDocumentFileWs } from '@/utils/filews';
import { convertBase64ToBlob, getAge, imgToBase64, isEmail, removeMascaraCpf, searchCepService, validarCpf } from '@/utils/servicos-utils';
import { EnderecoModel } from '@/components/models/endereco';
import { EnumTipoDocumentoPaciente } from '@/components/models/enumTipoDocumentoPaciente';
import imgPaciente from '../../../assets/paciente.jpeg';
import { openNotification, typesNotification } from '@/utils/notifications';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import moment from 'moment';
import { domainEstadosCivisSicad, domainGrauEscolaridade, getGrauParentesco, getUserByCpf, getUserSicad } from '@/config/servicos-utils';
import { createPaciente, getPacienteById } from '@/components/service/pacienteService';
import loadGif from '@/assets/load.gif';

export default {
  name: 'FormPacienteDependente',
  components: {},
  props: {
    idPac: {
      type: String,
      required: false,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      errors: [],
      dataDocuments: [],
      submitted: false,
      especialidade: [],
      subEspecialidade: [],
      enumTipoDocumento: [],
      enumGrauParentesco: [],
      funcoesAtivas: [],
      estadosCivis: [],
      grauEscolaridade: [],
      militares: [],
      carregado: false,
      columns: [
        {
          title: 'Tipo Documento',
          dataIndex: 'tipoDocumento',
          key: 'tipoDocumento',
          slots: { customRender: 'tipoDocumento' },
        },
        {
          title: 'Arquivo',
          dataIndex: 'nomeArquivo',
          key: 'nomeArquivo',
          slots: { customRender: 'nomeArquivo' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      form: {
        tipoPaciente: undefined,
        id: undefined,
        cpf: undefined,
        nome: undefined,
        rgCivil: undefined,
        naturalidade: undefined,
        telefoneCelular: '',
        telefoneResidencial: '',
        estadoCivil: undefined,
        grauEscolaridade: undefined,
        grauParentesco: undefined,
        endereco: undefined,
        idAnexoFileImg: undefined,
        dtNascimento: undefined,
        idade: undefined,
        email: undefined,
        convenios: [],
        numeroConvenio: undefined,
        documentos: [],
        imagem: undefined,
        dependenteMilitar: {},
        profissao: undefined,
      },
      outForm: {
        numero: undefined,
        complemento: undefined,
        logradouro: undefined,
        setor: undefined,
        cidade: undefined,
        uf: undefined,
        lote: undefined,
        quadra: undefined,
      },
    };
  },
  validations() {
    return {
      form: {
        nome: {
          required,
        },
        dtNascimento: {
          required,
        },
        idade: {
          required,
        },
        endereco: {
          required,
        },
        email: {
          required,
          email,
        },
        naturalidade: {
          required,
        },
        tipoPaciente: {
          required,
        },
        convenios: {
          required,
        },
        grauParentesco: {
          required,
        },
        dependenteMilitar: {
          required,
        },
      },
    };
  },
  async created() {
    await this.getGrauParentesco();
    await this.onInit();
  },
  methods: {
    async onInit() {
      await this.getEstadosCivisSicad();
      await this.getGrauEscolaridade();
      this.getTipoDocumento();

      if (this.idPac) {
        this.$route.query.id = this.idPac;
      }
      if (this.$route.query.id && !this.carregado) {
        await getPacienteById(this.$route.query.id).then(async (p) => {
          document.getElementById('imgFoto').src = loadGif;
          this.form = p.data;
          await this.patchFormSicad(p.data.cpf);
          await this.patchForm();
          this.carregado = true;
        });
      } else {
        let dependenteMilitar = JSON.parse(localStorage.getItem('dependenteMilitar'));

        if (!dependenteMilitar) {
          this.$router.push('/paciente-page');
        } else {
          if (dependenteMilitar.cpfDependente) {
            await getUserByCpf(removeMascaraCpf(dependenteMilitar.cpfDependente)).then(async (r) => {
              this.form.dependenteMilitar.nome = r.data.nome;
              this.form.dependenteMilitar.cpf = r.data.cpf;
            });
          } else {
            this.form.dependenteMilitar.nome = dependenteMilitar.servidor.nome;
            this.form.dependenteMilitar.cpf = dependenteMilitar.servidor.cpf;
          }

          if (dependenteMilitar.grauParentescoId) {
            this.form.grauParentesco = { id: dependenteMilitar.grauParentescoId, nome: dependenteMilitar.grauParentesco.toUpperCase() };
          }
          this.form.nome = dependenteMilitar.nome;
          if (dependenteMilitar.dtNascimento) {
            let dataNascimento = new Date(dependenteMilitar.dtNascimento);
            this.form.dtNascimento = moment(dataNascimento).format('DD/MM/YYYY');
            this.form.idade = getAge(dataNascimento);
          }

          await getUserByCpf(removeMascaraCpf(this.form.dependenteMilitar.cpf)).then(async (r) => {
            if (r.data) {
              this.form.endereco = r.data.endereco;
              await this.patchForm();
            }
          });

          localStorage.removeItem('dependenteMilitar');

          this.form.tipoPaciente = 'DEPENDENTE';
          document.getElementById('imgFoto').src = imgPaciente;
          document.getElementById('cpf').disabled = false;
          document.getElementById('idade').disabled = false;
          document.getElementById('naturalidade').disabled = false;
        }
      }
    },
    calcularIdade() {
      if (this.form.dtNascimento) {
        //let dataNascimento = new Date(this.form.dtNascimento);
        //this.form.dtNascimento = moment(dataNascimento).format('DD/MM/YYYY');
        this.form.idade = getAge(this.form.dtNascimento);
      }
    },
    async patchForm() {
      // endereço
      this.outForm.cep = this.form.endereco.cep;
      this.outForm.logradouro = this.form.endereco.logradouro;
      if (this.form.endereco.bairro && this.form.endereco.bairro.id) {
        this.outForm.setor = this.form.endereco.bairro.nome;
      } else {
        this.outForm.setor = this.form.endereco.bairro;
      }

      if (this.form.endereco.municipio && this.form.endereco.municipio.id) {
        this.outForm.cidade = this.form.endereco.municipio.nome;
        this.outForm.uf = this.form.endereco.municipio.uf;
      } else {
        this.outForm.cidade = this.form.endereco.cidade;
        this.outForm.uf = this.form.endereco.uf;
      }
      this.outForm.numero = this.form.endereco.numero;
      this.outForm.complemento = this.form.endereco.complemento;
      this.outForm.lote = this.form.endereco.lote;
      this.outForm.quadra = this.form.endereco.quadra;
      this.$refs.cep.value = this.form.endereco.cep;

      this.form.endereco = this.outForm;
      // convenios
      this.form.convenios.forEach((c) => {
        switch (c) {
          case 'PARTICULAR':
            this.$refs.particular.checked = true;
            break;
          case 'DOACAO':
            this.$refs.doacao.checked = true;
            break;
          case 'IPASGO':
            this.$refs.ipasgo.checked = true;
            break;
          default:
            break;
        }
      });
      // documentos
      this.dataDocuments = this.form.documentos;
      //carregar img
      await this.carregarImg(this.form.idAnexoFileImg);
    },
    async patchFormSicad(cpf) {
      await getUserByCpf(cpf).then(async (r) => {
        if (r.data) {
          let dataNascimento = new Date(r.data.dtNascimento);
          this.form.cpf = cpf;
          this.form.dtNascimento = moment(dataNascimento).format('DD/MM/YYYY');
          this.form.imagem = r.data.imagem;
          this.form.status = r.data.status;
          if (!this.$route.query.id) {
            await this.patchDataSicad(r.data);
          }
        }
      });
    },
    async uploadFile() {
      let validarTamanho = isArquivoValido('', '', this.$refs.files.files[0].size, true);
      if (this.$refs.tipoDocumento.value) {
        if (validarTamanho.tamanho) {
          await sendDocumentFileWs(this.$refs.files.files[0], 'TOKEN', 'ssp').then((r) => {
            const obj = {
              idAnexoFileWs: r.data.id,
              tipoDocumento: this.$refs.tipoDocumento.value,
              nomeArquivo: r.data.nomeOriginal,
            };
            this.dataDocuments.push(obj);
            openNotification(typesNotification.success, 'Arquivo enviado com sucesso');
          });
        } else {
          openNotification(typesNotification.error, 'Tamanho de arquivo não suportado.');
        }
      }
    },
    async searchCep() {
      if (this.$refs.cep.value.length === 10) {
        await searchCepService(this.$refs.cep.value.replace('.', '').replace('-', '')).then((r) => {
          if (r.data && r.data[0]) {
            this.outForm = {};
            this.form.endereco = EnderecoModel(r.data[0]);
            this.outForm.cep = this.$refs.cep.value;
            this.outForm.logradouro = EnderecoModel(r.data[0]).logradouro;
            this.outForm.setor = EnderecoModel(r.data[0]).bairro;
            this.outForm.cidade = EnderecoModel(r.data[0]).cidade;
            this.outForm.uf = EnderecoModel(r.data[0]).uf;
          }
        });
      }
    },
    removeDataArchive(record) {
      if (!this.form.id) {
        this.dataDocuments.splice(this.dataDocuments.indexOf(this.dataDocuments.find((r) => r.tipoDocumento === record.tipoDocumento && r.nomeArquivo === record.nomeArquivo)), 1);
      } else {
        this.form.documentos.splice(this.form.documentos.indexOf(this.form.documentos.find((r) => r.idAnexoFileWs === record.idAnexoFileWs)), 1);
        this.saveAndContinue();
      }
    },

    async getEstadosCivisSicad() {
      await domainEstadosCivisSicad().then((r) => (this.estadosCivis = r.data));
    },

    async getGrauEscolaridade() {
      await domainGrauEscolaridade().then((r) => (this.grauEscolaridade = r.data));
    },
    async handleSearch(value) {
      value.length >= 3
        ? await getUserSicad({ nome: value }).then((r) => {
            this.militares = r.data;
          })
        : (this.militares = []);
    },
    onSelect(value) {
      this.form.dependenteMilitar = value.nome;
    },

    openUploadImg() {
      let button = document.getElementById('uploadImg');
      button.click();
    },
    async uploadFileImg() {
      let validos = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      let nomeArquivo = this.$refs.uploadImg.files[0].name;
      let tamanho = this.$refs.uploadImg.files[0].size;
      let valido = isArquivoValido(nomeArquivo, validos, tamanho);

      if (valido.tamanho && valido.extensoes)
        await sendDocumentFileWs(this.$refs.uploadImg.files[0], 'TOKEN', 'ssp').then(async (r) => {
          document.getElementById('imgFoto').src = await imgToBase64(this.$refs.uploadImg.files[0]);
          this.form.idAnexoFileImg = r.data.id;
        });
      else openNotification(typesNotification.error, 'Extensão ou tamanho de arquivo inválido.');
    },
    setConvencio(convenio) {
      this.form.convenios = new Array();
      switch (convenio) {
        case 'PARTICULAR':
          if (this.$refs.particular.checked) {
            this.form.convenios.push(convenio);
          } else {
            this.form.convenios.splice(convenio, 1);
          }
          break;
        case 'DOACAO':
          if (this.$refs.doacao.checked) {
            this.form.convenios.push(convenio);
          } else {
            this.form.convenios.splice(convenio, 1);
          }
          break;
        case 'IPASGO':
          if (this.$refs.ipasgo.checked) {
            this.form.convenios.push(convenio);
          } else {
            this.form.convenios.splice(convenio, 1);
          }
          break;
        default:
          break;
      }
    },
    async saveAndContinue(valid, back) {
      this.submitted = valid;
      await this.montarObjeto();
      if (!valid) {
        this.form.cpf = this.form.cpf.replaceAll('.', '').replace('-', '');
        this.form.dependenteMilitar.cpf = this.form.dependenteMilitar.cpf.replaceAll('.', '').replace('-', '');
        await createPaciente(this.form).then((r) => {
          this.form.id = r.data.id;
          openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          this.form.id = r.data.id;
          if (back) {
            this.$router.push({ path: '/paciente' });
          }
        });
      } else {
        openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
        return false;
      }
    },
    async montarObjeto() {
      if (this.outForm.numero) {
        this.form.endereco.numero = this.outForm.numero;
      }
      if (this.form.endereco) {
        this.form.endereco.complemento = this.outForm.complemento;
      }
      this.form.documentos = this.dataDocuments;
    },
    getTipoDocumento() {
      this.enumTipoDocumento = EnumTipoDocumentoPaciente();
    },
    async getGrauParentesco() {
      await getGrauParentesco().then((r) => {
        this.enumGrauParentesco = r.data;
      });
    },
    validarCpf() {
      let value = this.$refs.cpf.value;
      this.$refs.cpf.classList.value = ['form-control'];
      if (!validarCpf(value)) {
        this.$refs.cpf.classList.value = ['form-control is-invalid'];
      }
    },
    validarEmail() {
      let value = this.$refs.email.value;
      this.$refs.email.classList.value = ['form-control'];
      if (!isEmail(value)) this.$refs.email.classList.value = ['form-control is-invalid'];
    },
    async patchDataSicad(form) {
      this.form.nome = form.nome;
      this.form.tipoPaciente = form.tipoPaciente;
      this.form.email = form.email;
      this.form.telefoneCelular = form.telefoneCelular;
      this.form.telefoneResidencial = form.telefoneResidencial;
      this.form.posto = form.posto;
      if (this.form.dtNascimento === 'Data inválida' || !this.form.dtNascimento) {
        this.form.dtNascimento = '';
        document.getElementById('dtNascimento').value = '';
        document.getElementById('dtNascimento').disabled = false;
      }
      if (form.idade) {
        this.form.idade = form.idade;
      } else {
        document.getElementById('idade').disabled = false;
      }
      this.form.rgCivil = form.rgCivil;
      this.form.imagem = form.imagem;
      this.form.tipoPaciente = form.vinculo === 'TERCEIRIZADO' ? 'DEPENDENTE' : form.vinculo;

      if (form.naturalidade) {
        this.form.naturalidade = form.naturalidade.nome + '-' + form.naturalidade.uf;
      } else {
        document.getElementById('naturalidade').disabled = false;
      }

      this.form.grauEscolaridade = form.grauEscolaridade;
      this.form.estadoCivil = form.estadoCivil;

      // endereço
      if (form.endereco) {
        this.outForm.cep = form.endereco.cep;
        this.outForm.logradouro = form.endereco.logradouro;
        if (form.endereco.bairro && form.endereco.bairro.id) {
          this.outForm.setor = form.endereco.bairro.nome;
        } else {
          this.outForm.setor = form.endereco.bairro;
        }

        if (form.endereco.municipio && form.endereco.municipio.id) {
          this.outForm.cidade = form.endereco.municipio.nome;
          this.outForm.uf = form.endereco.municipio.uf;
        } else {
          this.outForm.cidade = form.endereco.cidade;
          this.outForm.uf = form.endereco.uf;
        }
        this.outForm.numero = form.endereco.numero;
        this.outForm.complemento = form.endereco.complemento;
        this.outForm.lote = form.endereco.lote;
        this.outForm.quadra = form.endereco.quadra;
        this.$refs.cep.value = form.endereco.cep;

        this.form.endereco = this.outForm;
      }

      // convenios
      this.form.convenios.forEach((c) => {
        switch (c) {
          case 'PARTICULAR':
            this.$refs.particular.checked = true;
            break;
          case 'DOACAO':
            this.$refs.doacao.checked = true;
            break;
          case 'IPASGO':
            this.$refs.ipasgo.checked = true;
            break;
          default:
            break;
        }
      });

      // documentos
      this.dataDocuments = this.form.documentos;
      //carregar img
      await this.carregarImg(this.form.idAnexoFileImg);
    },
    stringTipoDocumento(documento) {
      let tipoDoc = this.enumTipoDocumento.find((etp) => etp.tipo === documento.tipoDocumento || etp.descricao === documento.tipoDocumento);
      if (tipoDoc) {
        return tipoDoc.descricao;
      }
    },
    async baixarArquivo(document) {
      await downloadDocumentFileWs(document.idAnexoFileWs, document.nomeArquivo);
    },
    async carregarImg(idImg) {
      if (idImg)
        await loadDocumentFileWs(idImg).then(async (img) => {
          document.getElementById('imgFoto').src = await imgToBase64(img);
        });
      else if (this.form.imagem) {
        let imgBlob = convertBase64ToBlob('data:image/jpg;base64,' + this.form.imagem);
        document.getElementById('imgFoto').src = await imgToBase64(imgBlob);
      } else {
        document.getElementById('imgFoto').src = imgPaciente;
      }
    },
  },
};
</script>

<style scoped>
#uploadImg {
  display: none;
}
</style>
